
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M10 0C15.5246 0 20 4.47824 20 10C20 15.5218 15.5218 20 10 20C4.47824 20 0 15.5218 0 10C0 4.47824 4.47824 0 10 0ZM12.3047 12.7679H7.6981C6.35882 12.7679 5.02511 14.1016 4.79353 15.7645L4.64565 16.8052C6.11886 17.9687 7.97991 18.6607 10.0028 18.6607C12.0257 18.6607 13.8867 17.966 15.3599 16.8052L15.2121 15.7645C14.9805 14.1211 13.6747 12.7958 12.3465 12.7706L12.3047 12.7679ZM10 1.33929C5.21764 1.33929 1.33929 5.21763 1.33929 10C1.33929 12.168 2.13449 14.149 3.45145 15.6669L3.45703 15.6306C3.45982 15.611 3.46261 15.5943 3.4654 15.5748C3.78348 13.3119 5.60826 11.4648 7.63672 11.4286H7.6981H12.3047C14.3555 11.4286 16.2165 13.2896 16.5374 15.5748L16.5513 15.6669C17.8683 14.149 18.6635 12.1652 18.6635 10C18.6607 5.21763 14.7852 1.33929 10 1.33929ZM10 3.25893C11.9727 3.25893 13.5714 4.8577 13.5714 6.83036C13.5714 8.80301 11.9727 10.4018 10 10.4018C8.02734 10.4018 6.42857 8.80301 6.42857 6.83036C6.42857 4.8577 8.02734 3.25893 10 3.25893ZM10 4.59821C8.76674 4.59821 7.76786 5.5971 7.76786 6.83036C7.76786 8.06362 8.76674 9.0625 10 9.0625C11.2333 9.0625 12.2321 8.06362 12.2321 6.83036C12.2321 5.5971 11.2333 4.59821 10 4.59821Z"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'UserCircle',
    }) as DefineComponent
    </script>
    